import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query UpstreamFlowsFilteredByFieldWithoutPersonalSpaceQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
